<template>
  <article
          :class="{
              [uiClass]: true,
              'tablet:flex justify-between gap-8': !!imgUri,
              'tablet:flex-row-reverse': odd && !!imgUri
            }"
          class="rounded-img"
  >
    <div>
      <header
              :class="{
                  'flex gap-4 items-center': hasIcon || iconRef,
                }"
              class="mb-4 tablet:pt-8"
      >
        <component
                :is="iconComponent"
                v-if="hasIcon"
                class="size-12"
        />
        <figure v-if="iconRef" class="size-18">
          <media-source
                  :alt="page.title"
                  :dimensions="[{ width: 48, height: 48 }, { width: 96, height: 96 }, { width: 192, height: 192 }]"
                  :sizes="'80px'"
                  :uri="iconRef"
                  as="img"
                  class-name="w-full h-auto object-cover rounded-full"
                  format="jpg"
          />
        </figure>
        <hgroup>
          <h2 class="section-title text-grey font-semibold mb-2">{{ page.title }}</h2>
          <h3 v-if="page?.meta?.subtitle" class="uppercase text-tertiary font-semibold">{{
              page.meta.subtitle
            }}</h3>
        </hgroup>
      </header>
      <ContentRenderer :value="page" class="with-free-text mb-8"/>
      <ButtonCta
              v-if="page?.meta?.cta"
              :cta="page.meta.cta"
              class="btn-light w-full mb-8 tablet:w-auto"
      >
        <template #icon-end>
          <ArrowRightIcon class="size-6 ms-2"/>
        </template>
      </ButtonCta>
    </div>
    <picture v-if="imgUri" class="tablet:w-[40%] tablet:basis-[40%] tablet:shrink-0 tablet:mt-8">
      <media-source
              :dimensions="imageDimensions"
              :sizes="imageSizes"
              :uri="imgUri"
              as="source"
              format="webp"
      />
      <media-source
              :alt="page.title"
              :dimensions="imageDimensions"
              :sizes="imageSizes"
              :uri="imgUri"
              as="img"
              class-name="w-full h-auto object-cover rounded-img"
              format="jpg"
      />
    </picture>
  </article>
</template>
<script lang="ts" setup>
import {ArrowRightIcon} from "@heroicons/vue/16/solid";
import type {PageCollectionItemBase} from "@nuxt/content";

const {page, odd, imageSizes, imageDimensions} = defineProps<{
    page: PageCollectionItemBase,
    odd: boolean,
    imageDimensions: { width: number, height?: number }[],
    imageSizes: string,
}>();
const hasIcon = computed<boolean>(() => !!page?.meta?.icon);
const iconComponent = computed(() => {
    if (!hasIcon.value) return null
    return defineAsyncComponent(() =>
            import(`~/components/icon/${page.meta.icon}.vue`)
    )
});
const imgUri = computed<string>(() => (page.meta?.imageRef as string || '').replace('/assets', ''));
const uiClass = computed<string>(() => {
    return ({
        'blue': 'bg-quadriary text-dark p-4 tablet:p-8 mb-8 tablet:mb-6 ',
        'green': 'bg-brand-light text-dark p-4 tablet:p-8 tablet:mb-6 ',
        'blank': 'bg-transparent text-dark tablet:px-4 laptop:px-8',
    } as Record<string, string>)[page?.meta?.theme as string || 'blue']!;
});
const iconRef = computed<string>(() => (page.meta?.iconRef as string || '').replace('/assets', ''));
</script>